// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._404_errorContainer__DQv9N {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  background: #0a0a0a;
}

._404_errorContent__NeEJm {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  padding: 20px;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

._404_number__07aUk {
  font-size: 180px;
  font-weight: 700;
  font-family: 'Poppins', sans-serif;
  color: #fff;
  line-height: 1;
  animation: _404_float__xuRqG 3s ease-in-out infinite;
  text-shadow: 0 0 20px rgba(34, 197, 94, 0.3);
}

._404_circle__HKWcJ {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #00ff9d 0%, #00b36b 100%);
  border-radius: 50%;
  margin: 0 10px;
  position: relative;
  animation: _404_pulse__XZCHh 3s ease-in-out infinite;
  box-shadow: 0 0 30px rgba(34, 197, 94, 0.3);
}

._404_circle__HKWcJ::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 140px;
  height: 140px;
  background: #0a0a0a;
  border-radius: 50%;
  transform: translate(-50%, -50%);
}

._404_text__kRvm0 {
  width: 100%;
  font-size: 24px;
  color: #fff;
  margin: 20px 0 10px;
  font-family: 'Poppins', sans-serif;
  opacity: 0.9;
  text-shadow: 0 0 10px rgba(34, 197, 94, 0.3);
}

._404_subtext__HaMOf {
  width: 100%;
  font-size: 16px;
  color: #888;
  margin: 0 0 20px;
  font-family: 'Poppins', sans-serif;
}

._404_button__\\+9WCV {
  background: linear-gradient(135deg, #00ff9d 0%, #00b36b 100%);
  color: #000;
  border: none;
  padding: 15px 40px;
  font-size: 18px;
  font-weight: 600;
  border-radius: 30px;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  font-family: 'Poppins', sans-serif;
  text-transform: uppercase;
  letter-spacing: 1px;
}

._404_button__\\+9WCV:hover {
  transform: translateY(-2px);
  box-shadow: 0 0 20px rgba(0, 255, 157, 0.4);
}

._404_button__\\+9WCV:active {
  transform: translateY(0);
}

@keyframes _404_float__xuRqG {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
}

@keyframes _404_pulse__XZCHh {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 30px rgba(34, 197, 94, 0.3);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 50px rgba(34, 197, 94, 0.5);
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/404.module.css"],"names":[],"mappings":"AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,WAAW;EACX,cAAc;EACd,oDAAwC;EACxC,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,oDAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,kCAAkC;EAClC,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,qDAAqD;EACrD,kCAAkC;EAClC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,2CAA2C;EAC7C;EACA;IACE,sBAAsB;IACtB,2CAA2C;EAC7C;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap');\n\n.errorContainer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  background: #0a0a0a;\n}\n\n.errorContent {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 20px;\n  padding: 20px;\n  text-align: center;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.number {\n  font-size: 180px;\n  font-weight: 700;\n  font-family: 'Poppins', sans-serif;\n  color: #fff;\n  line-height: 1;\n  animation: float 3s ease-in-out infinite;\n  text-shadow: 0 0 20px rgba(34, 197, 94, 0.3);\n}\n\n.circle {\n  width: 150px;\n  height: 150px;\n  background: linear-gradient(135deg, #00ff9d 0%, #00b36b 100%);\n  border-radius: 50%;\n  margin: 0 10px;\n  position: relative;\n  animation: pulse 3s ease-in-out infinite;\n  box-shadow: 0 0 30px rgba(34, 197, 94, 0.3);\n}\n\n.circle::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 140px;\n  height: 140px;\n  background: #0a0a0a;\n  border-radius: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.text {\n  width: 100%;\n  font-size: 24px;\n  color: #fff;\n  margin: 20px 0 10px;\n  font-family: 'Poppins', sans-serif;\n  opacity: 0.9;\n  text-shadow: 0 0 10px rgba(34, 197, 94, 0.3);\n}\n\n.subtext {\n  width: 100%;\n  font-size: 16px;\n  color: #888;\n  margin: 0 0 20px;\n  font-family: 'Poppins', sans-serif;\n}\n\n.button {\n  background: linear-gradient(135deg, #00ff9d 0%, #00b36b 100%);\n  color: #000;\n  border: none;\n  padding: 15px 40px;\n  font-size: 18px;\n  font-weight: 600;\n  border-radius: 30px;\n  cursor: pointer;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  font-family: 'Poppins', sans-serif;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 0 20px rgba(0, 255, 157, 0.4);\n}\n\n.button:active {\n  transform: translateY(0);\n}\n\n@keyframes float {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-20px);\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n    box-shadow: 0 0 30px rgba(34, 197, 94, 0.3);\n  }\n  50% {\n    transform: scale(1.05);\n    box-shadow: 0 0 50px rgba(34, 197, 94, 0.5);\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorContainer": `_404_errorContainer__DQv9N`,
	"errorContent": `_404_errorContent__NeEJm`,
	"number": `_404_number__07aUk`,
	"float": `_404_float__xuRqG`,
	"circle": `_404_circle__HKWcJ`,
	"pulse": `_404_pulse__XZCHh`,
	"text": `_404_text__kRvm0`,
	"subtext": `_404_subtext__HaMOf`,
	"button": `_404_button__+9WCV`
};
export default ___CSS_LOADER_EXPORT___;
